import React, { useEffect } from 'react';
import { ListGroupItem } from 'react-bootstrap';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { useContext } from './Context';
import TableItem from './TableItem';

export default function Table() {
  const { dispatch, actions, state } = useContext();

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    actions.sort(
      dispatch,
      state.affiliateTrainingSteps,
      result.source.index,
      result.destination.index,
    );
  };

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  if (state.affiliateTrainingSteps === null) {
    return (
      <ListGroupItem align="center">
        Please, wait ...
      </ListGroupItem>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, _snapshot) => (
          <>
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="list-group"
            >
              {state.affiliateTrainingSteps
                && state.affiliateTrainingSteps.map((item, index) => (
                  <TableItem key={item.id} index={index} affiliateTrainingStep={item} />
                ))}
            </ul>
            {provided.placeholder}
          </>
        )}
      </Droppable>
    </DragDropContext>
  );
}
